import fetch from "auth/FetchInterceptor";
import { CDN_BASE_URL } from "configs/AppConfig";
import { ApiConstant } from "constants/ApiConstant";
import { CMS_JSON_PATH } from "constants/CmsConstants";
import Utils from "utils";

const CmsService = {};

CmsService.fetchCmsData = async function () {
  try {
    
    const response = await window.fetch(`${CDN_BASE_URL}${CMS_JSON_PATH}`, {
      method: "GET",
      headers: {
        "Cache-Control": "no-cache, no-store, must-revalidate",
        "Pragma": "no-cache",
        "Expires": "0",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    
    return data;
  } catch (error) {
    console.error("Error fetching CMS data:", error);
    throw new Error(error.message || "Failed to fetch CMS data");
  }
};

CmsService.generateCmsPresignedUrl = function ( params,data) {
  console.warn(params);
  return fetch({
    url: ApiConstant.GENERATE_PRESIGNED_URL,
    method: "POST",
    data,
    params: Utils.filterHeaderParams(params),
  });
};
CmsService.uploadCmsContent = async function (uploadUrl, jsonData) {
  try {
    // Use native fetch for presigned URL - NOT your interceptor
    const response = await window.fetch(uploadUrl, {
      method: 'PUT', // Presigned URLs typically use PUT, not POST
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(jsonData, null, 2), // Properly stringify JSON
    });

    if (!response.ok) {
      throw new Error(`Upload failed: ${response.status} ${response.statusText}`);
    }

    return {
      success: true,
      message: 'Content uploaded successfully',
      status: response.status,
      response
    };
  } catch (error) {
    throw new Error(error.message || 'Upload failed');
  }

  
};

CmsService.uploadMedia = async function (uploadUrl, file) {
  try {
    // Append filename to the upload URL

    
    const response = await window.fetch(uploadUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': file.type, // Use file's MIME type
      },
      body: file, // Upload the file directly
    });

    if (!response.ok) {
      throw new Error(`Media upload failed: ${response.status} ${response.statusText}`);
    }

    return {
      success: true,
      message: 'Media uploaded successfully',
      status: response.status,
      response
    };
  } catch (error) {
    throw new Error(error.message || 'Media upload failed');
  }
};

CmsService.deleteMedia = function ( data) {
  return fetch({
    url: ApiConstant.GENERIC_R2_CONTENT_DELETE_URL,
    method: "POST",
    data,
  });
};



export default CmsService;
